<template lang="html">
  <transition name="slide">
    <nav v-if="site && pages">
      <router-link
        v-if="!isMobile || isActive"
        class="title-link"
        :to="{ name: 'home' }"
      >
        <div class="subtitle uc" @click="isActive = false">
          {{ site.subtitle }}
        </div>
        <h1 class="title black" @click="isActive = false">
          {{ site.title }}
        </h1>
      </router-link>
      <div class="nav-inner" :class="{ home: this.$route.name === 'home' }">
        <div
          class="arrow noselect"
          v-if="isMobile"
          @click="isActive = !isActive"
        >
          <h1 class="pr" v-if="isActive">&uarr;</h1>
          <h1 class="pr" v-else>&darr;</h1>
        </div>
        <div
          v-if="isMobile && !isActive"
          class="current-page"
          @click="isActive = false"
        >
          <h1
            v-if="
              pageName && $route.name !== 'home' && $route.name !== 'contact'
            "
          >
            {{ pageName.title }}
          </h1>
          <h1 v-if="$route.name == 'contact'">Contact</h1>
          <div v-if="$route.name == 'home'" class="home-menu">
            <h1
              @click="
                $root.$emit('news');
                isArchive = false;
              "
              :class="{ grey: isArchive }"
            >
              NEWS
            </h1>
            <h1
              @click="
                $root.$emit('archive');
                isArchive = true;
              "
              :class="{ grey: !isArchive }"
            >
              ARCHIVE
            </h1>
          </div>
        </div>
        <div
          class="nav-menu"
          v-if="!isMobile || isActive"
          @click="isActive = false"
        >
          <div class="nav-menu-item" v-for="page in pages" :key="page.uid">
            <router-link :to="{ name: page.uid }">
              <h1>{{ page.title }}</h1>
            </router-link>
            <div class="subpages" v-if="page.uid !== 'activities'">
              <router-link
                v-for="subpage in page.subpages"
                :key="subpage.uid"
                class="uc"
                :to="'/' + page.uid + '/' + subpage.uid"
                >{{ subpage.title }}</router-link
              >
            </div>
          </div>
        </div>
      </div>
      <div class="nav-bottom">
        <a class="logo big pr" href="https://uzh.ch" target="_blank">
          <img src="./../assets/logos/uzh_logo_e_pos.svg" alt="" />
        </a>
        <!-- <a class="logo" href="https://instagram.com" target="_blank">
          <img class="logo" src="./../assets/logos/instagram.svg" alt="" />
        </a> -->
      </div>
    </nav>
  </transition>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      isActive: false,
      isMobile: false,
      isArchive: false
    };
  },
  mounted() {
    this.isItMobile();
    window.addEventListener("resize", this.isItMobile);
  },
  computed: {
    ...mapState(["site"]),
    pages() {
      let pages = this.$store.state.site.pages;
      if (pages) {
        return pages.filter(page => {
          if (page.uid !== "home") {
            return page;
          }
        });
      } else {
        return pages;
      }
    },
    pageName() {
      if (this.$route.name !== "semester" && this.$route.name !== "team") {
        return this.pages.filter(page => page.uid == this.$route.name)[0];
      } else {
        if (this.$route.name === "semester") {
          return { title: "Teaching" };
        } else {
          return { title: "Faculty" };
        }
      }
    }
  },
  methods: {
    addHash() {
      this.isArchive = !this.isArchive;
      this.$root.$emit("newsCategory");
    },
    isItMobile() {
      if (window.innerWidth > 768) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },
    openMenu() {
      if (this.isMobile) {
        this.isActive = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nav-inner {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: var(--lh);
  @media only screen and (max-width: 768px) {
    margin-bottom: 0;
  }
  .nav-menu {
    flex: 1 0 auto;
    .nav-menu-item {
      .subpages {
        display: none;
      }
      a.router-link-active ~ .subpages {
        display: block;
        @media only screen and (max-width: 768px) {
          display: none;
        }
      }
    }
  }
  @media only screen and (max-width: 768px) {
    flex-direction: row;
    justify-content: flex-start;
    &.home {
      // justify-content: space-between;
    }
    .home-menu {
      display: flex;
      > h1:first-of-type {
        margin-right: calc(0.5 * var(--lh));
      }
    }
    .nav-menu {
      flex: 1 0 auto;
    }
  }
  .arrow {
    cursor: pointer;
    user-select: none;
  }
  a {
    display: block;
  }
  @media only print {
    a {
      display: none;
      &.router-link-active {
        display: block;
      }
    }
  }
}
.nav-bottom {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  @media only print {
    display: none;
  }
  @media only screen and (max-width: 768px) {
    display: none;
  }
  .logo {
    display: inline-block;
    opacity: 0.5;
    &:hover {
      opacity: 1;
    }
    &.big {
      img {
        height: calc(3.5 * var(--fs));
      }
    }
    img {
      height: calc(2 * var(--fs));
      display: inline-block !important;
      width: auto !important;
    }
  }
}
</style>
